import { z } from 'zod';

export const clienteSchema = z.object({
  nome: z.string().min(3, 'Nome deve ter pelo menos 3 caracteres').max(100),
  email: z.string().email('Email inválido').optional().or(z.literal('')),
  telefone: z
    .string()
    .min(8, 'Telefone deve ter pelo menos 8 caracteres')
    .max(20)
    .optional()
    .or(z.literal('')),
  endereco: z.string().max(200).optional().or(z.literal('')),
  ativo: z.boolean().optional(),
  receberCobrancaAutomatica: z.boolean().optional().default(true),
  consentimentoLGPD: z.boolean().optional(),
});

export type ClienteSchema = z.infer<typeof clienteSchema>;
